import { AppInventoryOption, type AppInventoryState } from '@openx/types/targeting/appInventory.ts';
import { noop } from '@openx/utils/noop.ts';
import { createReducer } from '@reduxjs/toolkit';
import { useReducer } from 'react';
import {
  getEmptyInventoryState,
  resetContent,
  resetFilter,
  setComparisonOpValue,
  setContent,
  setContentCategoryOp,
} from '../../shared/AppInventory/inventoryHelpers.ts';
import { updateAppBundleIdState } from '../../shared/InventoryAndContent/utils.ts';

export const useAppInventory = (initialState: AppInventoryState) => {
  // we using reduxjs/toolkit so we don't need to spread object data
  const reducer = createReducer(initialState, builder => {
    builder
      .addCase(setContent, (_state, action) => {
        return action.payload;
      })
      .addCase(resetContent, () => {
        return getEmptyInventoryState();
      })
      .addCase(resetFilter, (state, action) => {
        const { contentOption } = action.payload;
        state[contentOption] = getEmptyInventoryState()[contentOption];
      })
      .addCase(setComparisonOpValue[AppInventoryOption.APP_BUNDLE_ID], (state, action) => {
        updateAppBundleIdState(state[AppInventoryOption.APP_BUNDLE_ID], action.payload);
      })
      .addCase(setContentCategoryOp[AppInventoryOption.APP_BUNDLE_ID], (state, action) => {
        state[AppInventoryOption.APP_BUNDLE_ID].op = action.payload;
      })
      .addCase(setComparisonOpValue[AppInventoryOption.APP_GROUP], (state, action) => {
        const { values, comparisonType } = action.payload;
        if (!state[AppInventoryOption.APP_GROUP].val) {
          state[AppInventoryOption.APP_GROUP].val = {};
        }
        const val = state[AppInventoryOption.APP_GROUP].val!;
        if (values.length) {
          val[comparisonType] = values;
        } else {
          delete val[comparisonType];
        }
      })
      .addCase(setContentCategoryOp[AppInventoryOption.APP_GROUP], (state, action) => {
        state[AppInventoryOption.APP_GROUP].op = action.payload;
      })
      .addDefaultCase(noop);
  });

  const [inventoryState, dispatchInventory] = useReducer(reducer, initialState);

  return { dispatchInventory, inventoryState };
};
